import { render, staticRenderFns } from "./Articll_listSc.vue?vue&type=template&id=7413088c&"
import script from "./Articll_listSc.vue?vue&type=script&lang=js&"
export * from "./Articll_listSc.vue?vue&type=script&lang=js&"
import style0 from "./Articll_listSc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports